import React from 'react';
import ReactDOM from 'react-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import App from './App';

/* iOS re-orientation fix */
if (
  navigator.userAgent.match(/iPhone/i) ||
  navigator.userAgent.match(/iPad/i)
) {
  /* iOS hides Safari address bar */
  window.addEventListener('load', () => {
    setTimeout(() => {
      window.scrollTo(0, 1);
    }, 1000);
  });
}

const Root = () => (
  <>
    <CssBaseline />
    <App />
  </>
);

ReactDOM.render(<Root />, document.querySelector('#root'));
